import React, { Component } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import HomepageFirst from '../../components/homepage/HomepageFirst';
import HomepageSecond from '../../components/homepage/HomepageSecond';
import HomepageThird from '../../components/homepage/HompageThird';
import HomepageFourth from '../../components/homepage/HomepageFourth';
import HomepageFifth from '../../components/homepage/HomepageFifth';
import HomepageLast from '../../components/homepage/HomepageLast';
import NavBar from '../../components/nav/NavBar';
import FooterHover from '../../components/footer/FooterHover';
import Mouse from '../../components/mouse/Mouse';
import Attention from '../../components/attention/Attention';
import windowSize from 'react-window-size';
import { license } from '../../common/config';
import { withTranslation } from 'react-i18next';
class Homepage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            first: true,
            index: 0,
        };
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    onLeave(origin, destination, direction) {
        if (destination.index == 1 && origin.index == 0) {
            this.setState({
                first: false,
            });
        }

        if (destination.index == 0 && origin.index == 1) {
            this.setState({
                first: true,
            });
        }
        this.setState({
            index: destination.index,
        });
    }

    ar_names = ['ما هو التوحد', 'خدمات', 'مصادر', 'التدريب', 'اشترك'];
    en_names = ['Autism', 'Services', 'Resources', 'Training', 'Subscribe'];

    render() {
        return (
            <>
                {this.state.index === 5 ? (
                    ''
                ) : (
                    <Mouse
                        blue
                        ar_name={this.ar_names[this.state.index]}
                        en_name={this.en_names[this.state.index]}
                        index={this.state.index}
                    />
                )}
                {this.state.width > 900 ? (
                    <>
                        <NavBar
                            first={this.state.first}
                            width={this.state.width}
                            height={this.state.height}
                        />

                        <ReactFullpage
                            onLeave={this.onLeave.bind(this)}
                            licenseKey={license}
                            scrollingSpeed={1000}
                            render={(comp) => (
                                <div className='hp-container'>
                                    <div className='section blue-slide'>
                                        <HomepageFirst />
                                    </div>
                                    <div
                                        id='hp-second'
                                        className='section purple-slide'
                                    >
                                        <HomepageSecond />
                                    </div>
                                    <div className='section blue-slide'>
                                        <HomepageThird />
                                    </div>
                                    <div className='section purple-slide'>
                                        <HomepageFourth
                                            articles={this.props.articles}
                                        />
                                    </div>
                                    <div className='section purple-slide'>
                                        <HomepageFifth
                                            courses={this.props.courses}
                                            files={this.props.files}
                                        />
                                    </div>
                                    <div className='section blue-slide'>
                                        <HomepageLast
                                            index={this.state.index}
                                            emails={this.props.emails}
                                        />
                                    </div>
                                </div>
                            )}
                        />
                    </>
                ) : (
                    <>
                        <NavBar fixed />

                        <div className='hp-container-nofp'>
                            <div className='hp-section blue-slide'>
                                <HomepageFirst />
                            </div>
                            <div className='hp-section purple-slide'>
                                <HomepageSecond />
                            </div>
                            <div className='hp-section blue-slide'>
                                <HomepageThird />
                            </div>
                            <div className='hp-section purple-slide'>
                                <HomepageFourth
                                    articles={this.props.articles}
                                />
                            </div>
                            <div className='hp-section purple-slide'>
                                <HomepageFifth
                                    courses={this.props.courses}
                                    files={this.props.files}
                                />
                            </div>
                            <div className='hp-section blue-slide'>
                                <HomepageLast
                                    index={this.state.index}
                                    emails={this.props.emails}
                                />
                            </div>
                        </div>
                    </>
                )}
                {this.state.width > 900 ? <Attention /> : <></>}
                {this.state.width > 900 ? <FooterHover white /> : <></>}
            </>
        );
    }
}

export default withTranslation()(windowSize(Homepage));
